var map = {
	"./air-nga-en/assets/captain-icon.png": 40716,
	"./ais-tai-en/assets/captain-icon.png": 43107,
	"./ais-tai-tha/assets/captain-icon.png": 54495,
	"./demo-arabic/assets/captain-icon.png": 51159,
	"./demo-et-en/assets/captain-icon.png": 86816,
	"./demo-romanian/assets/captain-icon.png": 81990,
	"./demo-um-en/assets/captain-icon.png": 46263,
	"./dtac-tai-en/assets/captain-icon.png": 41190,
	"./dtac-tai-tha/assets/captain-icon.png": 7524,
	"./ethiotel-et-amh/assets/captain-icon.png": 96946,
	"./ethiotel-et-en/assets/captain-icon.png": 31197,
	"./mtn-cg-fr/assets/captain-icon.png": 49652,
	"./mtn-ci-fr/assets/captain-icon.png": 35444,
	"./mtn-cmr-fr/assets/captain-icon.png": 49384,
	"./mtn-gha-en/assets/captain-icon.png": 45477,
	"./mtn-nga-en/assets/captain-icon.png": 63513,
	"./mtn-zam-en/assets/captain-icon.png": 51319,
	"./saf-ke-en/assets/captain-icon.png": 35224,
	"./saudi-uae-en/assets/captain-icon.png": 77351,
	"./tlk-za-en/assets/captain-icon.png": 10380,
	"./vc-za-en/assets/captain-icon.png": 75016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12966;